import {ActionBase} from '../../helpers/reduxHelpers';

/*
 * Action types.
 */

export enum PushStatusActionsEnum {
  PUSH_DISCONNECTED = '@@pushStatus/PUSH_DISCONNECTED',
}

/*
 * Types.
 */

export interface PushStatusDisconnectedAction extends ActionBase {
  type: PushStatusActionsEnum.PUSH_DISCONNECTED;
}

/*
 * Union Actions.
 */

export type PushStatusAction = PushStatusDisconnectedAction;

/*
 * Action Creators.
 */

export function pushStatusDisconnectedAction(): PushStatusDisconnectedAction {
  return {
    type: PushStatusActionsEnum.PUSH_DISCONNECTED,
  };
}
